import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox, IconButton } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { Delete, Edit, Close, Check } from '@mui/icons-material';
import { StyledTableBodyCell, StyledTableRow } from 'components/common/Styles';
import { emptyString } from 'utils/constants';

const VerificationTypeUserGroupItemComponent = ({
  verificationTypeUserGroup,
  onPropertyChanged,
  index,
  userGroups,
  allUserGroups,
  onDelete,
  onCancel,
  onEdit
}) => {
  const { t } = useTranslation();

  const userGroup = allUserGroups.find(
    x => x.id === verificationTypeUserGroup.userGroupId || x.id === verificationTypeUserGroup?.userGroup?.id
  );

  return (
    <StyledTableRow>
      {verificationTypeUserGroup.userGroupsInEdit ? (
        <>
          <StyledTableBodyCell sx={{ w: 1 / 2 }}>
            <Autocomplete
              fullWidth
              isClearable={false}
              label={t('VerificationTypes.UserGroup')}
              value={verificationTypeUserGroup.editValue.userGroup}
              options={userGroups}
              valueKey='id'
              labelKey='name'
              onChange={event => onPropertyChanged('userGroup', event, index)}
              isSearchable={true}
              required
            />
          </StyledTableBodyCell>
          <StyledTableBodyCell>
            <FormControlLabel
              control={
                <Checkbox
                  checked={verificationTypeUserGroup.editValue.viewReportYN}
                  color='primary'
                  onChange={event => onPropertyChanged('viewReportYN', event.target.checked, index)}
                />
              }
            />
          </StyledTableBodyCell>
          <StyledTableBodyCell>
            <FormControlLabel
              control={
                <Checkbox
                  checked={verificationTypeUserGroup.editValue.viewSummaryYN}
                  color='primary'
                  onChange={event => onPropertyChanged('viewSummaryYN', event.target.checked, index)}
                />
              }
            />
          </StyledTableBodyCell>
        </>
      ) : (
        <>
          <StyledTableBodyCell sx={{ w: 1 / 2 }}>{userGroup?.name || emptyString}</StyledTableBodyCell>
          <StyledTableBodyCell>
            {verificationTypeUserGroup.viewReportYN === true ? <Check color='success' /> : <Close />}
          </StyledTableBodyCell>
          <StyledTableBodyCell>
            {verificationTypeUserGroup.viewSummaryYN === true ? <Check color='success' /> : <Close />}
          </StyledTableBodyCell>
        </>
      )}
      <StyledTableBodyCell align='right'>
        {verificationTypeUserGroup.userGroupsInEdit ? (
          <IconButton
            size='small'
            color='primary'
            title={t('Tooltips.Cancel')}
            onClick={() => {
              onCancel(index);
            }}
          >
            <Close fontSize='small' />
          </IconButton>
        ) : (
          <IconButton size='small' color='primary' title={t('Tooltips.Edit')} onClick={() => onEdit(index)}>
            <Edit fontSize='small' />
          </IconButton>
        )}
        <IconButton
          size='small'
          color='primary'
          title={t('Tooltips.Delete')}
          onClick={() => onDelete(index)}
          disabled={!verificationTypeUserGroup.userGroup.id}
        >
          <Delete />
        </IconButton>
      </StyledTableBodyCell>
    </StyledTableRow>
  );
};

VerificationTypeUserGroupItemComponent.propTypes = {
  verificationTypeUserGroup: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  userGroups: PropTypes.array.isRequired,
  allUserGroups: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func
};

export default VerificationTypeUserGroupItemComponent;
